import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// Suppress CCP postMessage null errors when dialer is closed (avoid uncaught error alerts)
window.addEventListener('error', (e) => {
  const msg = (e.message || e.error?.message || '').toString();
  if (msg.includes('postMessage') && msg.includes('null')) {
    e.preventDefault();
    e.stopPropagation();
    return true;
  }
  return false;
});
window.addEventListener('unhandledrejection', (e) => {
  const msg = (e.reason?.message || String(e.reason || '')).toString();
  if (msg.includes('postMessage') && msg.includes('null')) {
    e.preventDefault();
    e.stopPropagation();
  }
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));